import React from 'react';
import styled from 'styled-components';
import _Drawer from '@material-ui/core/Drawer';
import { Box } from 'rebass';

import SideViewHeader from './side-view-header';
import SideViewContent from './side-view-content';
import MediaQuery from 'react-responsive';

const Drawer = styled(_Drawer)<Partial<SideViewProps>>`
  z-index: 2147483001 !important;

  & .MuiBackdrop-root {
    cursor: pointer;
  }

  & .MuiDrawer-paper {
    z-index: 2147483002;
    height: ${({ height }) => height ?? '100%'} !important;
    width: ${({ width }) => width ?? '450px'} !important;
    border-top-right-radius: ${({ borderradiustopright }) => borderradiustopright ?? '0'};
    border-top-left-radius: ${({ borderradiustopleft }) => borderradiustopleft ?? '0'};
    border-bottom-right-radius: ${({ borderradiusbottomright }) => borderradiusbottomright ?? '0'};
    border-bottom-left-radius: ${({ borderradiusbottomleft }) => borderradiusbottomleft ?? '0'};
  }
`;

export type iPositionTypes = 'bottom' | 'top' | 'left' | 'right' | undefined;

export type SideViewProps = {
  children: React.ReactNode;
  width?: string;
  height?: string;
  isOpenSideView: boolean;
  position?: iPositionTypes;
  borderradiustopright?: string;
  borderradiustopleft?: string;
  borderradiusbottomright?: string;
  borderradiusbottomleft?: string;
} & SideViewContextType;

type SideViewContextType = {
  onCloseSideView: () => void;
};

type ISideView<P> = React.FunctionComponent<P> & {
  Header: typeof SideViewHeader;
  Content: typeof SideViewContent;
};

export const SideViewContext = React.createContext<SideViewContextType | null>(null);

export function useSideViewContext() {
  const context = React.useContext(SideViewContext);
  if (!context) {
    throw new Error(
      `SideView compound components cannot be rendered outside the SideView component`,
    );
  }
  return context;
}

const SideView: ISideView<SideViewProps> = ({
  children,
  onCloseSideView,
  isOpenSideView,
  position = 'right',
  width = '520px',
  height = '100%',
  borderradiustopright = '0',
  borderradiustopleft = '0',
  borderradiusbottomright = '0',
  borderradiusbottomleft = '0',
}) => {
  const value = { onCloseSideView };

  return (
    <MediaQuery maxWidth={768}>
      {matches => (
        <SideViewContext.Provider value={value}>
          <Drawer
            anchor={position}
            open={isOpenSideView}
            onClose={onCloseSideView}
            borderradiustopright={borderradiustopright}
            borderradiustopleft={borderradiustopleft}
            borderradiusbottomright={borderradiusbottomright}
            borderradiusbottomleft={borderradiusbottomleft}
            height={height}
            width={width}
          >
            <Box
              width={matches ? '100%' : width}
              maxWidth={matches ? '100%' : width}
              minWidth={matches ? '100%' : width}
              height={height}
            >
              {children}
            </Box>
          </Drawer>
        </SideViewContext.Provider>
      )}
    </MediaQuery>
  );
};

SideView.Header = SideViewHeader;
SideView.Content = SideViewContent;

export default SideView;
